import { useContext } from 'react';
import { ThemeContext } from 'styled-components/macro';
import { Theme } from '@oberoninternal/travelbase-ds/constants/theme';

export const useThemeContext = () => useContext(ThemeContext) as Theme;
